// extracted by mini-css-extract-plugin
module.exports = {"keypad":"r1m18","submit":"OtDqo","delete":"UYEPP","erase":"S5F1c","deleteIcon":"FIxAJ","space":"QouHO","spaceIcon":"zf6Kl"};